/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect } from 'react';
import { ConfigureRollbarProps as UseConfigureRollbarParams } from './configure-rollbar.types';

export function useConfigureRollbar({ router, user, ui }: UseConfigureRollbarParams): void {
  const { query: cName } = router;

  const { id: userId, firstName, lastName, fullName, createdAt } = user;
  const { variant } = ui;

  useEffect(() => {
    global.window.Rollbar.configure({
      payload: {
        person: {
          id: userId,
          firstName,
          lastName,
          username: fullName,
          createdAt,
        },
        variant,
        dispensaryCName: cName,
      },
    });
  }, [cName, createdAt, firstName, fullName, lastName, userId, variant]);
}
